import { connect } from 'react-redux';
import Cassandra from './Cassandra';
import { setActiveUploadWizard } from '../../../redux/modules/data.cassandra.module';

export const mapDispatchToProps = {
  setActiveUploadWizard,
};

export default connect(null, mapDispatchToProps)(Cassandra);
